module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE HEART OF REDNESS")]), _vm._v(". Copyright © 2000 by Zakes Mda. All rights reserved. Printed in the United States of America. For information, address Picador, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.picadorusa.com",
      "target": "_blank"
    }
  }, [_vm._v("www.picadorusa.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Picador"), _c('sup', [_vm._v("®")]), _vm._v(" is a U.S. registered trademark and is used by Farrar, Straus and Giroux under license from Pan Books Limited.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("For information on Picador Reading Group Guides, as well as ordering, please"), _c('br'), _vm._v("contact the Trade Marketing department at St. Martin’s Press."), _c('br'), _vm._v("Phone: 1-800-221-7945 extension 763"), _c('br'), _vm._v("Fax: 212-677-7456"), _c('br'), _vm._v("E-mail: trademarketing@stmartins.com")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Mda, Zakes.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("The heart of redness / Zakes Mda.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("         p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN 0-312-42174-5       ISBN 978-0-312-42174-8")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("1. Triangles (Interpersonal relations)—Fiction. 2. Xhosa (African people)—Fiction. 3. South Africa—Fiction. 4. Villages—Fiction. 5. Casinos—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("PR9369.3.M4 H43 2002"), _c('br'), _vm._v("823'.914—dc21                                                           2002025008")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("First published in the United States by Farrar, Straus and Giroux")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("First published in South Africa by Oxford University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('br'), _c('br'), _vm._v("10   9   8   7   6")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0